export { LargeTitle, largeTitleClassNames } from './components/presets/LargeTitle/index';
